import { CreateBusinessData } from '../../business';
import { DAYS_OF_WEEK, formatDayName } from '../../constants';

interface AvailabilitySectionProps {
  availability: CreateBusinessData['availability'];
  errors: Record<string, string>;
  onChange: (day: keyof CreateBusinessData['availability'], checked: boolean) => void;
}

/**
 * AvailabilitySection component for selecting weekly availability
 */
export function AvailabilitySection({ availability, errors, onChange }: AvailabilitySectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Availability <span className="text-red-500">*</span>
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-7 gap-3">
        {DAYS_OF_WEEK.map((day) => (
          <label key={day} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={availability[day]}
              onChange={(e) => onChange(day, e.target.checked)}
              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              aria-invalid={!!errors.availability}
            />
            <span className="text-sm text-gray-700">{formatDayName(day)}</span>
          </label>
        ))}
      </div>
      {errors.availability && (
        <p className="text-red-600 text-sm mt-2" role="alert">
          {errors.availability}
        </p>
      )}
    </div>
  );
}
